export default {
  "leadConvertedAndMemberCreated": "lead convertito e socio creato",
  "members": "Soci",
  "thisMemberDoesNotHaveAPhoneNumberOnFile": "Questo socio non ha un numero di telefono sul file.",
  "pleaseSelectAClubInstanceFromTheTopRightSwitcherToManageMembers": "Si prega di selezionare un'istanza del club dal commutatore a destra superiore per gestire i soci.",
  "importMembers": "Importazioni",
  "addMember": "Aggiungi un socio",
  "searchMembers": "I soci della ricerca...",
  "noMembersFound": "Nessun socio trovato",
  "deleteMember": "Eliminare i soci",
  "thisActionCannotBeUndone": "Questa azione non può essere annullata",
  "areYouSureYouWantToDelete": "Sei sicuro di voler eliminare",
  "thisWillPermanentlyRemoveTheirMembershipRecordAndAllAssociatedData": "? Questo rimuoverà definitivamente il loro record di appartenenza e tutti i dati associati.",
  "deleting": "Cancellare...",
  "describeTheMessageYouWantToSendAndILlWriteItForYouYouCanTypeOrUseYourVoice": "Descrivi il messaggio che vuoi inviare, e lo scriverò per te. È possibile digitare o utilizzare la voce.",
  "eGWriteAFriendlyFollowUpAboutTheMemberDinnerNextFridayAndAskIfTheyHaveAnyDietaryRestrictions": "ad esempio, 'Scrivi un follow-up amichevole circa la cena socio il prossimo Venerdì e chiedere se hanno restrizioni dietetiche.'",
  "stopListening": "Smettila di ascoltare",
  "useVoice": "Usa la voce",
  "generateMessage": "Generare il messaggio",
  "member": "Socio",
  "sorryIWasUnableToGenerateAMessagePleaseTryAgain": "Mi dispiace, non sono stato in grado di generare un messaggio.",
  "makeCall": "Fai una chiamata",
  "contactMember": "Contatta l'utente",
  "failedToSendMessage": "Non ha inviato un messaggio",
  "lead": "Lead",
  "message": "Messaggio",
  "willSendViaYourConnectedEmailProviderGmailOutlook": "Invierà tramite il tuo provider di posta elettronica connesso (Gmail/Outlook)",
  "aiSuggestedReplies": "AI Risposte suggerite",
  "generatingIdeas": "Generando idee...",
  "messageSentSuccessfully": "Messaggio inviato con successo!",
  "call": "Chiama",
  "loadingActivityHistory": "Caricamento della storia dell'attività...",
  "noActivityHistoryRecordedYet": "Nessuna cronologia delle attività registrata.",
  "activity": "Attività",
  "reciprocalVisit": "Visita reciproca",
  "unknown": "Sconosciuto",
  "noSmsInteractionsYet": "Nessuna interazione SMS per il momento.",
  "noEmailInteractionsYet": "Nessuna interazione e-mail ancora.",
  "noCallInteractionsYet": "Non ci sono ancora interazioni con le chiamate.",
  "noInteractionsLoggedForThisMemberYet": "Non ci sono ancora interazioni registrate per questo socio.",
  "openInSmsModule": "Aperto nel modulo SMS",
  "loadingMoreInteractions": "Caricamento di più interazioni...",
  "overdue": "Scaduto",
  "annualDues": "Data annuale:",
  "interactions": "Interazioni:",
  "activities": "Attività:",
  "memberSince": "socio dal",
  "viewProfile": "Visualizza il profilo",
  "callMember": "Denominazione",
  "editMember": "Modifica utente",
  "spouse": "Sposa",
  "partner": "Partner",
  "parent": "Parità",
  "sibling": "Sobling",
  "guardian": "Guardiano",
  "other": "Altro",
  "unableToLoadProfileGroups": "Incapace di caricare gruppi di profili.",
  "vegetarian": "Vegetariano",
  "vegan": "Vegano",
  "pescatarian": "Pescataire",
  "glutenFree": "Senza glutine",
  "dairyFree": "Senza latticini",
  "halal": "Halal",
  "kosher": "Kosher",
  "nutAllergy": "Allergia alla nuca",
  "otherAllergy": "Altre allergia",
  "otherRequirement": "Altri requisiti",
  "preferredTitle": "Titolo preferito",
  "firstName": "Nome",
  "middleNames": "Nomi medi",
  "lastName": "Cognome",
  "preferredName": "Nome preferenziale",
  "gender": "Genere",
  "dateOfBirth": "Data di nascita",
  "maritalStatus": "Stato civile",
  "anniversary": "Anniversario",
  "signInEmail": "E-mail di iscrizione",
  "readOnlyAccountEmail": "E-mail dell'account di sola lettura",
  "contactEmail": "E-mail di contatto",
  "secondaryEmail": "E-mail secondaria",
  "mobile": "Mobile mobile",
  "homeTelephone": "Home telefono",
  "workTelephone": "Telefono di lavoro",
  "personal": "Personale",
  "profile": "Profilo",
  "contact": "Contatto",
  "addresses": "Indirizzo",
  "emergency": "Emergenza",
  "family": "Famiglia",
  "dietary": "Aliquote",
  "vehicles": "Veicoli",
  "unableToLoadActivityDetails": "Incapace di caricare i dettagli dell'attività",
  "pleaseChooseAnInteractionType": "Si prega di scegliere un tipo di interazione.",
  "unableToSaveInteraction": "Incapace di salvare l'interazione",
  "failedToAddInteraction": "Non è riuscito ad aggiungere l'interazione",
  "backToMembers": "Torna ai soci",
  "memberNotFound": "socio non trovato.",
  "golfBooking": "Golf Prenotazione",
  "racquetBooking": "Prenotazione racchetta",
  "fitnessClass": "Classe di fitness",
  "spaBooking": "Prenotazione di Spa",
  "reciprocalClubVisit": "Visita del Club Reciproco",
  "roomReservation": "Prenotazione camera",
  "eventAttendance": "Partecipazione all'evento",
  "activityDetails": "Dettagli dell'attività",
  "unknownMember": "socio sconosciuto",
  "viewProfilePicture": "Visualizza l'immagine del profilo",
  "phone": "Telefono",
  "membershipNumber": "Numero di iscrizione",
  "annualDues2": "Adeguamenti annuali",
  "weddingDate": "Data di matrimonio",
  "anniversary2": "Anniversario:",
  "address": "Indirizzo",
  "emergencyContact": "Contatto di emergenza",
  "loadingFamilyMembers": "Caricamento dei membri della famiglia...",
  "noLinkedFamilyMembers": "Nessun membro della famiglia collegato.",
  "boats": "Barche",
  "boat": "Barca",
  "horses": "Cavalli",
  "horse": "Cavallo",
  "sportLevels": "Livelli sportivi",
  "golfHcp": "Handicap golf",
  "tennisLevel": "Livello di tennis",
  "padelLevel": "Livello di Padel",
  "visualMemberProfileCards": "Schede di profilo dei soci visuali",
  "profileGroups": "Gruppi di profilati",
  "loading": "Caricamento…",
  "primaryPostal": "Postale primario",
  "noAddressesRecorded": "Nessun indirizzo registrato.",
  "emergencyContact2": "Contatto di emergenza",
  "accepted": "• Accettato",
  "memberConsentRequests": "Richiesta di consenso",
  "incomingToMember": "In arrivo a socio",
  "outgoingFromMember": "Esecuzione dal socio",
  "removal": "Rimozione",
  "add": "Aggiungi",
  "noDietaryRequirementsRecorded": "Nessun requisito alimentare registrato.",
  "primaryVehicle": "Veicolo primario",
  "noVehiclesRecorded": "Nessun veicolo registrato.",
  "memberDetails": "Dettagli dei soci",
  "crmLeadHistory": "CRM storia del lead",
  "achievementsHistory": "Risultati / Storia",
  "interactions2": "Interazioni (",
  "activityHistory": "Storia dell'attività (",
  "financial": "Finanziario",
  "memberInteractionHistory": "Storia dell'interazione",
  "completeRecordOfAllCommunicationsAndInteractions": "Registrazione completa di tutte le comunicazioni e le interazioni",
  "filter": "Filtra",
  "allInteractions": "Tutte le interazioni",
  "all": "Tutti",
  "activityHistory2": "Storia dell'attività",
  "loggedActivitiesForThisMember": "Attivitā per questo socio",
  "bookingMemberName": "Nome del socio della prenotazione",
  "bookingMemberNumber": "Numero dei soci della prenotazione",
  "service": "Servizio",
  "spaService": "Trattamento spa",
  "therapist": "Operatore",
  "notAssigned": "Non assegnato",
  "room": "Camera",
  "destinationClub": "Destinazione club",
  "reciprocalType": "Tipo reciproco",
  "confirmationNumber": "Numero di conferma",
  "guests": "Ospiti",
  "checkIn": "Prego, check-in",
  "checkOut": "Check-out",
  "event": "Evento",
  "attendees": "Partecipanti",
  "weCouldnTMatchThisActivityToAKnownDetailModalYet": "Non potevamo ancora corrispondere a questa attività ad un noto dettaglio modale.",
  "title": "Titolo:",
  "occurredAt": "Occurred a:",
  "typeKey": "Tipo di chiave:",
  "players": "Giocatori",
  "guest": "Ospite",
  "unknownPlayer": "Giocatore sconosciuto",
  "hcp": "Hcp:",
  "noPlayersRecorded": "Nessun giocatore registrato.",
  "addOns": "Extra",
  "addOn": "Extra",
  "qty": "Qtà:",
  "noAddOnsRecorded": "Nessun componente aggiuntivo registrato.",
  "loadingTypes": "I tipi di carico...",
  "noMembershipTypesFound": "Nessun tipo di abbonamento trovato",
  "active": "Attivo",
  "sortBy": "Più o meno...",
  "newestFirst": "La prima volta",
  "nameAZ": "Nome (A-Z)",
  "nameZA": "Nome (Z-A)",
  "membershipAsc": "Appartenenza # (asc)",
  "membershipDesc": "Appartenenza # (desc)",
  "mostInteractions": "La maggior parte delle interazioni",
  "mostActivities": "La maggior parte delle attività",
  "inCreditBy": "In credito",
  "balanceDue": "Bilancia dovuta",
  "noOverdueInvoices": "Nessuna fattura indebita",
  "unableToLoadFinancialData": "Incapace di caricare dati finanziari",
  "membershipDuesStatus": "Stato delle quote di iscrizione",
  "readOnlyDuesStatusAndRecentBillingActivity": "Lo stato dei due di sola lettura e la recente attività di fatturazione.",
  "youDonTHavePermissionToViewMemberFinancials": "Non hai il permesso di visualizzare i finanziari dei soci.",
  "currentDuesStatus": "Situazione delle quote correnti",
  "activeTemplate": "Modello attivo",
  "notConfigured": "Non configurato",
  "nextInvoiceDate": "Prossima data di fattura",
  "outstandingDuesBalance": "Bilancia dei due eccezionali",
  "latestDuesInvoice": "Ultimi debiti fattura",
  "noDuesInvoiceYet": "Nessuna fattura di due ancora",
  "latestDuesInvoiceDue": "Ultimi debiti fattura dovuta",
  "overdueDuesInvoices": "Fatture di debito indebito",
  "recentDuesPayments": "Pagamenti dovuti recenti",
  "financialSummary": "Riepilogo finanziario",
  "memberNetPaidBalanceAndOverdueInsights": "Rete dei soci pagata, equilibrio e intuizioni indebite.",
  "netPaidYtd": "Rete pagata YTD",
  "netPaidMtd": "MTD a pagamento netto",
  "netPaidWtd": "Rete pagata WTD",
  "netPaidToday": "Rete pagata oggi",
  "balance": "Bilancio",
  "latestOverdueInvoice": "Ultimi fattura in ritardo",
  "accountActivity": "Attività contabile",
  "canonicalMemberAccountChargesAndLedgerActivity": "Spese di conto dei soci canonici e attività di registro.",
  "noMemberAccountActivityFound": "Nessuna attività dell'account socio trovata.",
  "date": "Data",
  "type": "Tipo",
  "notRecorded": "Non registrato",
  "payments": "Pagamenti",
  "mostRecentPaymentsAndAllocations": "I pagamenti più recenti e le assegnazioni.",
  "noPaymentsFoundForThisMember": "Nessun pagamento trovato per questo socio.",
  "paidAt": "Pagato a",
  "allocations": "Destinazioni",
  "allocation": "assegnazione",
  "noAllocations": "Nessuna dotazione",
  "loadMore": "Caricamento di più",
  "unableToResolveClubForFamilyLinks": "Incapace di risolvere il club per i collegamenti familiari",
  "unableToResolveClubForMembershipTypes": "Incapace di risolvere il club per i tipi di appartenenza",
  "failedToLoadMembershipTypes": "Non è riuscito a caricare i tipi di abbonamento",
  "unableToSearchMembers": "Incapace di cercare i soci",
  "unableToDetermineClubForUpload": "Incapace di determinare il club per il caricamento",
  "uploadFailed": "Caricamento in corso",
  "errorClubContextIsNotAvailableCannotSaveMember": "Errore: Il contesto del Club non è disponibile. Non può salvare il socio.",
  "pleaseProvideFirstNameLastNameEmailAndMembershipNumber": "Si prega di fornire nome, cognome, e-mail e numero di iscrizione.",
  "phoneNumberIsRequired": "Il numero di telefono è richiesto",
  "pleaseEnterAValidPhoneNumberE164": "Si prega di inserire un numero di telefono valido (E.164)",
  "unableToUpdateMember": "Non è possibile aggiornare il socio",
  "unableToCreateMember": "Incapace di creare un socio",
  "failedToSaveMemberPleaseTryAgain": "Non sono riuscito a salvare il socio, per favore riprovate.",
  "areYouSureYouWantToDeleteThisMemberThisCannotBeUndone": "Sei sicuro di voler eliminare questo socio? Questo non può essere annullato.",
  "errorClubContextIsNotAvailableCannotDeleteMember": "Errore: Il contesto Club non è disponibile. Non è possibile eliminare il socio.",
  "unableToDeleteMember": "Incapace di eliminare il socio",
  "failedToDeleteMemberPleaseTryAgain": "Non è riuscito a eliminare il socio. Si prega di riprovare.",
  "unableToAddFamilyLink": "Incapace di aggiungere il link di famiglia",
  "unableToRemoveFamilyLink": "Incapace di rimuovere il link di famiglia",
  "addNewMember": "Aggiungi nuovo socio",
  "enterTheDetailsForTheClubMemberBelow": "Inserisci i dettagli per il socio del club qui sotto.",
  "memberAvatar": "Avatar socio",
  "uploading": "Caricamento...",
  "uploadPhoto": "Carica foto",
  "removePhoto": "Rimuovi la foto",
  "currentMembershipTerm": "Termine attuale per l'adesione",
  "unspecified": "Non specificato",
  "started": "Iniziato",
  "renewal": "; rinnovo",
  "renewalDateOverrideOptional": "Renewal date override (opzionale)",
  "firstName2": "Nome",
  "lastName2": "Ultimo nome",
  "localNumber": "Numero locale",
  "enterMembershipNumber": "Inserisci il numero di iscrizione",
  "joinDate": "Iscriviti Data",
  "dateOfBirth2": "Data di nascita",
  "linkRelatedMembersWithinThisClub": "Link associati soci all'interno di questo club.",
  "saveTheMemberFirstToAddFamilyLinks": "Salvare prima il membro per aggiungere i link familiari.",
  "searchMembers2": "soci della ricerca",
  "typeANameOrMembershipNumber": "Digitare un nome o un numero di iscrizione",
  "noMembershipNumber": "Nessun numero di iscrizione",
  "noMembersMatchThatSearch": "Nessun socio corrisponde a quella ricerca.",
  "relation": "Relazione",
  "linkedMembers": "soci collegati",
  "remove": "Rimuovi",
  "noFamilyMembersLinkedYet": "Nessun membro della famiglia ancora legato.",
  "deleteMember2": "Eliminare il socio",
  "renewalDateOverride": "Data di rinnovo personalizzata",
  "onlyCsvFilesAreSupportedForImportPleaseUploadACsvFile": "Solo CSV file sono supportati per l'importazione. Caricare un file .csv.",
  "currentClubContextIsMissingCannotImportMembersWithoutATenantId": "Manca il contesto attuale del club. Non possono importare i soci senza un documento d'identità inquilino.",
  "chooseImportMethod": "Scegli il metodo di importazione",
  "uploadExistingFile": "Carica file esistenti",
  "uploadACsvFileWithYourMemberData": "Carica un file CSV con i tuoi dati soci",
  "supportedFormatsCsv": "Formati supportati: CSV",
  "useOurTemplate": "Utilizzare il nostro modello",
  "downloadAPreFormattedTemplateWithSampleData": "Scarica un modello preformato con i dati del campione",
  "downloadTemplate": "Scarica Template",
  "fillOutTheTemplateAndUploadItAbove": "Compila il modello e caricalo sopra",
  "processingFile": "File di elaborazione...",
  "mapYourFields": "Mappa i tuoi campi",
  "matchYourDataColumnsToPrivanaFieldsRequiredFieldsAreMarkedWith": "Abbina le colonne di dati a Privana campi. I campi obbligatori sono contrassegnati con *",
  "selectColumn": "Seleziona la colonna...",
  "noMapping": "-- Nessuna corrispondenza --",
  "back": "Indietro",
  "previewImport": "Anteprima Importazione",
  "reviewTheFirst5RowsOfYourMappedDataBeforeImporting": "Verificare le prime 5 righe dei dati mappati prima di importare",
  "members2": "soci",
  "willBeImportedPleaseVerifyThePreviewDataLooksCorrectBeforeProceeding": "sarà importato. Si prega di verificare i dati di anteprima sembra corretto prima di procedere.",
  "backToMapping": "Torna a Mapping",
  "startImport": "Inizio Importazione",
  "importComplete": "Importazione completa",
  "successfullyImported": "Importato con successo",
  "failedToImport": "Non importato",
  "errors": "Errori:",
  "row": "Voce",
  "seeTheSalesInteractionsThatHappenedBeforeThisMemberJoined": "Vedere le interazioni di vendita che è successo prima che questo socio si è unito.",
  "loadingLeadHistory": "Caricamento della storia del lead...",
  "unableToLoadLeadHistoryForThisMember": "Incapace di caricare la cronologia dei lead per questo socio.",
  "originallyCapturedAsCrmLead": "Originariamente catturato come CRM lead.",
  "noCrmInteractionsWereLoggedForThisLead": "Nessuna interazione CRM è stata registrata per questo vantaggio.",
  "interaction": "Interazione",
  "name": "Nome",
  "membership": "Appartenenza",
  "associateCallRecord": "Record di chiamate associate",
  "multipleMembersMatchThePhoneNumberFromTheCallWith": "soci multipli corrispondono al numero di telefono dalla chiamata con",
  "unknownCaller": "Caller sconosciuto",
  "pleaseSelectWhichMemberToLogThisActivityFor": ". Si prega di selezionare quale socio per accedere a questa attività.",
  "linkedCount": "{count} collegati",
  "requiredMappings": "Si prega di mappare i seguenti campi richiesti: {fields}",
  "dueInDays": "Scadenza tra {count} giorni",
  "dueOn": "A causa di {date}",
  "years": "{count} anni",
  "overdueDays": "In ritardo di {count} giorni",
  "holes": "{count} buchi",
  "playersCount": "{count} giocatori",
  "onePlayer": "1 giocatore",
  "parseFailed": "Incapace di analizzare questo CSV . Controllare che ogni riga abbia le stesse colonne dell'intestazione.",
  "readFailed": "Non è possibile leggere questo file. Si prega di riprovare.",
  "preparationFailed": "Incapace di preparare questa riga. Controllare i suoi dati e riprovare.",
  "importFailed": "Non è possibile completare l'importazione. Si prega di riprovare.",
  "tenure": "({years} anni, {months} m)",
  "importFields": {
    "first_name": "Nome",
    "last_name": "Ultimo nome",
    "email": "E-mail",
    "phone": "Telefono",
    "membership_type": "Tipo di iscrizione",
    "membership_number": "Numero di iscrizione",
    "membership_term_start": "Inizio del periodo di iscrizione",
    "renewal_date_override": "Data di rinnovo personalizzata",
    "joined_at": "Data di iscrizione",
    "join_date": "Iscriviti Data",
    "status": "Stato",
    "emergency_contact": "Contatto di emergenza",
    "address": "Indirizzo",
    "notes": "Note",
    "membership_type_id": "Tipo di iscrizione ID",
    "membership_type_name": "Tipo di iscrizione Nome",
    "date_of_birth": "Data di nascita"
  },
  "fieldTypes": {
    "text": "Testo",
    "email": "E-mail",
    "select": "Opzione",
    "date": "Data"
  },
  "child": "Minore",
  "followUpPlaceholder": "Seguito dal Profilo di {name}",
  "loadMembersFailed": "Non è possibile caricare i soci. Si prega di riprovare.",
  "loadingMembers": "soci di carico...",
  "smsRouting": {
    "inbound_member_priority_alpha": {
      "label": "Auto-routed: Priorità dei soci",
      "tooltip": "Questo numero di telefono corrisponde a più persone in Privana . Questo inbound SMS è stato deviato automaticamente a questo socio utilizzando la prima regola alfabetica socio in entrata."
    },
    "explicit_member": {
      "label": "Routed: socio esplicito",
      "tooltip": "Questo SMS è stato inviato da un flusso socio-contesto, quindi è stato esplicitamente indirizzato a questo socio."
    },
    "explicit_lead": {
      "label": "Routed: Guida esplicita",
      "tooltip": "Questo SMS è stato inviato da un flusso di lead-contesto, quindi è stato esplicitamente indirizzato a questo vantaggio."
    },
    "single_match_member": {
      "label": "Routed: partita a singolo socio"
    },
    "single_match_lead": {
      "label": "Percorso: Single lead match"
    },
    "manual_outbound_selection": {
      "label": "Percorso: Selezione manuale"
    }
  },
  "communicationUnableToLoadSmsSettings": "Incapace di caricare SMS impostazioni",
  "communicationPleaseEnterInstructionsForWhatYouWantToSay": "Inserisci le istruzioni per quello che vuoi dire.",
  "communicationUnableToGenerateDraftsRightNowPleaseTryAgain": "Incapace di generare bozze ora. Si prega di riprovare.",
  "communicationRoutingSaved": "Routing salvato",
  "communicationSmsInteractionIsNowLinkedToTheSelectedPerson": "L'interazione SMS è ora legata alla persona selezionata.",
  "communicationUnableToSaveRouting": "Incapace di salvare il routing",
  "communicationMissingRecipientPhone": "Telefono destinatario mancante",
  "communicationSelectAFromNumber": "Seleziona una dal numero",
  "communicationPleaseChooseWhichClubNumberToSendFrom": "Si prega di scegliere il numero di club da inviare.",
  "communicationSmsBlocked": "SMS bloccati",
  "communicationThisMemberHasOptedOutOfSms": "Questo socio ha optato per SMS .",
  "communicationThisMemberHasNotConsentedToSms": "Questo socio non ha acconsentito a SMS .",
  "communicationUnableToSendSmsAtThisTime": "Incapace di inviare SMS in questo momento.",
  "communicationProviderDidNotAcceptTheMessagePleaseTryAgain": "Il Fornitore non ha accettato il messaggio. Si prega di riprovare.",
  "communicationSmsSent": "SMS inviati",
  "communicationMessageSentChooseWhoThisSmsShouldBeLoggedAgainst": "Messaggio inviato. Scegliere chi questo SMS dovrebbe essere registrato contro.",
  "communicationYourMessageIsOnItsWay": "Il tuo messaggio sta arrivando.",
  "communication160Characters": "/160 caratteri",
  "communicationFromNumber": "Dal numero",
  "communicationLoadingNumbers": "Caricamento numeri...",
  "communicationSelectANumber": "Seleziona un numero",
  "communicationNoSmsEnabledClubNumbersAreAvailableEnableSmsForADidInAdminVoipNumbers": "Nessun numero del club abilitato agli SMS è disponibile. Abilita gli SMS per un numero DID in Amministrazione → Numeri VoIP.",
  "communicationDraftingAReply": "Elaborazione di una risposta...",
  "communicationSuggestedReply": "Risposta suggerita",
  "communicationUseReply": "Usare la risposta",
  "communicationRegenerate": "Rigenerare",
  "communicationCouldnTDraftReply": "Non è stato possibile redigere una risposta.",
  "communicationWillSendViaTwilioSmsService": "Invierà via Twilio SMS servizio",
  "communicationThisNumberBelongsToMultiplePeopleInPrivanaWhoWasThisSmsIntendedFor": "Questo numero appartiene a più persone in Privana . Chi era questo SMS destinato a?",
  "communicationNoPhone": "Nessun telefono",
  "communicationNoRoutingCandidatesAvailable": "Nessun candidato di routing disponibile.",
  "communicationDescribeWhatYouWantToSendThenReviewAndEditTwoDraftSmsOptions": "Descrivi ciò che vuoi inviare, poi riesamina e modifica due bozzetta SMS opzioni.",
  "communicationInstruction": "Istruzione",
  "communicationExampleRemindThemTheirTourIsTomorrowAt10AmAndAskThemToReplyIfTheyNeedToReschedule": "Esempio: Ricordate loro il loro tour è domani alle ore 10 e chiedete loro di rispondere se hanno bisogno di riprogrammare.",
  "communicationGeneratingOptions": "Generando opzioni...",
  "communicationGenerateOptions": "Generare le opzioni",
  "communicationOption1": "Opzione 1",
  "communicationOption2": "Opzione 2",
  "communicationUseThis": "Usa questo",
  "communicationSmsThread": "Conversazione SMS",
  "communicationViewAndReplyWithoutLeavingThisPage": "Visualizza e risponde senza lasciare questa pagina.",
  "communicationUnableToLoadMessages": "Incapace di caricare i messaggi.",
  "communicationLoadingMessages": "Caricamento di messaggi...",
  "communicationNoMessagesInThisConversationYet": "Non ci sono ancora messaggi in questa conversazione.",
  "communicationConversation": "Conversazione",
  "communicationScrollToViewAllMessages": "Scorrere per visualizzare tutti i messaggi",
  "communicationNewEmail": "Nuova email",
  "communicationAddAtLeastOneRecipientToForwardReply": "Aggiungi almeno un destinatario a forward/reply.",
  "communicationMessageCannotBeEmpty": "Il messaggio non può essere vuoto.",
  "communicationUnableToSendEmail": "Non è possibile inviare e-mail",
  "communicationPleaseTryAgainInAMoment": "Si prega di riprovare in un momento.",
  "communicationEmailSent": "E-mail inviata",
  "communicationForwardSent": "Avanti inviato",
  "communicationReplySent": "Rispondi inviato",
  "communicationDeliverySucceededMessageMetadataIsSyncing": "La consegna è riuscita. I metadati del messaggio stanno sincronizzando.",
  "communicationMessageSent": "Messaggio inviato",
  "communicationSentSuccessfullyConversationRefreshIsStillSyncing": "Conversation rinfresco è ancora sincronizzazione.",
  "communicationEmailThread": "Filtro e-mail",
  "communicationLoadingConversation": "Caricamento della conversazione...",
  "communicationComposeANewEmailToStartAConversation": "Componi una nuova e-mail per iniziare una conversazione.",
  "communicationNoConversationMessagesAvailable": "Nessun messaggio di conversazione disponibile.",
  "communicationYou": "Tu sei",
  "communicationUnknownSender": "Inviatore sconosciuto",
  "communicationUnknownEmail": "E-mail sconosciuta",
  "communicationHideCcBcc": "Nascondi CC/BCC",
  "communicationCcBcc": "CC/BCC",
  "communicationCc": "CC",
  "communicationBcc": "BCC",
  "communicationComposeEmail": "E-mail Compose",
  "communicationComposeReply": "Scrivi una risposta",
  "communicationTone": "Tono",
  "communicationBrief": "Brief.",
  "communicationSyncingSent": "{status} . Sincronizzazione dell'articolo inviato...",
  "smsDelivery": {
    "queued": "In coda",
    "sending": "Inviare",
    "sent": "Inviato",
    "delivered": "Consegnato",
    "failed": "Non riuscito",
    "undelivered": "Non consegnata",
    "scheduled": "Programmato"
  },
  "player": "Giocatore",
  "profileChoices": {
    "female": "Femmina",
    "male": "Maschio",
    "nonBinary": "Non-binario",
    "undisclosed": "Preferire non dire",
    "other": "Altro",
    "single": "Singola",
    "married": "Sposato",
    "civilPartnership": "Partenariato civile",
    "partnered": "Partner",
    "separated": "Separato",
    "divorced": "Divorziato",
    "widowed": "Vedovo"
  }
};
